<div class='sidebar'>
    <div class="sidebarWrapper">
        <div class="sidebarMenu">
            <h5 class='sidebarTitle'>خانه</h5>
            <ul class='sidebarList'>
                <li class="sidebarListItem w-100" routerLink='/home' routerLinkActive='active'>
                    <i class="fa fa-home font-12" aria-hidden="true"></i>
                    <div class="white-no py-1" style="margin-right: 15px;">
                        خانه
                    </div>
                </li>
            </ul>

            <!-- Manufacturing (صنایع تولیدی) -->
            <div class="card" [ngClass]="{'collapsed': !isManufacturingOpen}">
                <div class="card-header d-flex align-items-center justify-content-between cursor-pointer"
                    (click)="toggleSection('manufacturing')">
                    <div>صنایع تولیدی</div>
                    <i class="fa" [ngClass]="isManufacturingOpen ? 'fa-angle-up' : 'fa-angle-down'" aria-hidden="true"></i>
                </div>
                <div class="card-body" [ngClass]="{'d-none': !isManufacturingOpen}">
                    <ul class='sidebarList'>
                        <li class="sidebarListItem w-100" routerLink='/manufacturing/balance-sheet-report' routerLinkActive='active'>
                            <i class="fa fa-book" aria-hidden="true"></i>
                            <div class="white-no py-1" style="margin-right: 15px;">گزارش صورت وضعیت مالی</div>
                        </li>
                        <li class="sidebarListItem w-100" routerLink='/manufacturing/get-income-statement' routerLinkActive='active'>
                            <i class="fa fa-usd" aria-hidden="true"></i>
                            <div class="white-no py-1" style="margin-right: 15px;">گزارش صورت سود و زیان</div>
                        </li>
                        <li class="sidebarListItem w-100" routerLink="/get-sales-report" routerLinkActive='active'>
                            <i class="fa fa-table" aria-hidden="true"></i>
                            <div class="white-no py-1" style="margin-right: 15px;">گزارش فروش‌های ماهانه</div>
                        </li>
                        <li class="sidebarListItem w-100" routerLink='/manufacturing/non-operational-income' routerLinkActive='active'>
                            <i class="fa fa-usd" aria-hidden="true"></i>
                            <div class="white-no py-1" style="margin-right: 15px;">گزارش درآمد غیرعملیاتی</div>
                        </li>
                        <li class="sidebarListItem w-100" routerLink='/status-of-viable-companies' routerLinkActive='active'>
                            <i class="fa fa-usd" aria-hidden="true"></i>
                            <div class="white-no py-1" style="margin-right: 15px;">گزارش تفسیری صفحه 4 - شرکت‌های سرمایه‌پذیر</div>
                        </li>
                        <li class="sidebarListItem w-100" routerLink='/interpretative-report-summary-page5' routerLinkActive='active'>
                            <i class="fa fa-usd" aria-hidden="true"></i>
                            <div class="white-no py-1" style="margin-right: 15px;">گزیده گزارش تفسیری صفحه 5</div>
                        </li>
                    </ul>
                </div>
            </div>

            <!-- Structural (صنایع ساختمانی) -->
            <div class="card" [ngClass]="{'collapsed': !isStructuralOpen}">
                <div class="card-header d-flex align-items-center justify-content-between cursor-pointer"
                    (click)="toggleSection('structural')">
                    <div>صنایع ساختمانی</div>
                    <i class="fa" [ngClass]="isStructuralOpen ? 'fa-angle-up' : 'fa-angle-down'" aria-hidden="true"></i>
                </div>
                <div class="card-body" [ngClass]="{'d-none': !isStructuralOpen}">
                    <ul class='sidebarList'>
                        <li class="sidebarListItem w-100" routerLink='/structural/balance-sheet' routerLinkActive='active'>
                            <i class="fa fa-book" aria-hidden="true"></i>
                            <div class="white-no py-1" style="margin-right: 15px;">گزارش صورت وضعیت مالی</div>
                        </li>
                        <li class="sidebarListItem w-100" routerLink='/structural/income-statement' routerLinkActive='active'>
                            <i class="fa fa-usd" aria-hidden="true"></i>
                            <div class="white-no py-1" style="margin-right: 15px;">گزارش صورت سود و زیان</div>
                        </li>
                        <li class="sidebarListItem w-100" routerLink='/structural/comprehensive-income' routerLinkActive='active'>
                            <i class="fa fa-line-chart" aria-hidden="true"></i>
                            <div class="white-no py-1" style="margin-right: 15px;">گزارش صورت سود و زیان جامع</div>
                        </li>
                        <li class="sidebarListItem w-100" routerLink='/structural/changes-in-equity' routerLinkActive='active'>
                            <i class="fa fa-balance-scale" aria-hidden="true"></i>
                            <div class="white-no py-1" style="margin-right: 15px;">گزارش صورت تغییرات در حقوق مالکانه</div>
                        </li>
                        <li class="sidebarListItem w-100" routerLink='/structural/cash-flow' routerLinkActive='active'>
                            <i class="fa fa-exchange" aria-hidden="true"></i>
                            <div class="white-no py-1" style="margin-right: 15px;">گزارش جریان وجوه نقد</div>
                        </li>
                        <li class="sidebarListItem w-100" routerLink='/structural/monthly-activity' routerLinkActive='active'>
                            <i class="fa fa-table" aria-hidden="true"></i>
                            <div class="white-no py-1" style="margin-right: 15px;">گزارش فعالیت ماهانه</div>
                        </li>
                    </ul>
                </div>
            </div>

            <!-- ServicesIndustry (صنایع خدماتی) -->
            <div class="card" [ngClass]="{'collapsed': !isServicesOpen}">
                <div class="card-header d-flex align-items-center justify-content-between cursor-pointer"
                    (click)="toggleSection('services')">
                    <div>صنایع خدماتی</div>
                    <i class="fa" [ngClass]="isServicesOpen ? 'fa-angle-up' : 'fa-angle-down'" aria-hidden="true"></i>
                </div>
                <div class="card-body" [ngClass]="{'d-none': !isServicesOpen}">
                    <ul class='sidebarList'>
                        <li class="sidebarListItem w-100" routerLink='/services-industry/balance-sheet' routerLinkActive='active'>
                            <i class="fa fa-book" aria-hidden="true"></i>
                            <div class="white-no py-1" style="margin-right: 15px;">گزارش صورت وضعیت مالی</div>
                        </li>
                        <li class="sidebarListItem w-100" routerLink='/services-industry/income-statement' routerLinkActive='active'>
                            <i class="fa fa-usd" aria-hidden="true"></i>
                            <div class="white-no py-1" style="margin-right: 15px;">گزارش صورت سود و زیان</div>
                        </li>
                        <li class="sidebarListItem w-100" routerLink='/services-industry/comprehensive-income' routerLinkActive='active'>
                            <i class="fa fa-line-chart" aria-hidden="true"></i>
                            <div class="white-no py-1" style="margin-right: 15px;">گزارش صورت سود و زیان جامع</div>
                        </li>
                        <li class="sidebarListItem w-100" routerLink='/services-industry/changes-in-equity' routerLinkActive='active'>
                            <i class="fa fa-balance-scale" aria-hidden="true"></i>
                            <div class="white-no py-1" style="margin-right: 15px;">گزارش صورت تغییرات در حقوق مالکانه</div>
                        </li>
                        <li class="sidebarListItem w-100" routerLink='/services-industry/cash-flow' routerLinkActive='active'>
                            <i class="fa fa-exchange" aria-hidden="true"></i>
                            <div class="white-no py-1" style="margin-right: 15px;">گزارش جریان وجوه نقد</div>
                        </li>
                        <li class="sidebarListItem w-100" routerLink='/services-industry/monthly-activity' routerLinkActive='active'>
                            <i class="fa fa-table" aria-hidden="true"></i>
                            <div class="white-no py-1" style="margin-right: 15px;">گزارش فعالیت ماهانه</div>
                        </li>
                    </ul>
                </div>
            </div>

            <!-- Investment (سرمایه‌گذاری) -->
            <div class="card" [ngClass]="{'collapsed': !isInvestmentOpen}">
                <div class="card-header d-flex align-items-center justify-content-between cursor-pointer"
                    (click)="toggleSection('investment')">
                    <div>سرمایه‌گذاری</div>
                    <i class="fa" [ngClass]="isInvestmentOpen ? 'fa-angle-up' : 'fa-angle-down'" aria-hidden="true"></i>
                </div>
                <div class="card-body" [ngClass]="{'d-none': !isInvestmentOpen}">
                    <ul class='sidebarList'>
                        <li class="sidebarListItem w-100" routerLink='/investment/balance-sheet' routerLinkActive='active'>
                            <i class="fa fa-book" aria-hidden="true"></i>
                            <div class="white-no py-1" style="margin-right: 15px;">گزارش صورت وضعیت مالی</div>
                        </li>
                        <li class="sidebarListItem w-100" routerLink='/investment/income-statement' routerLinkActive='active'>
                            <i class="fa fa-usd" aria-hidden="true"></i>
                            <div class="white-no py-1" style="margin-right: 15px;">گزارش صورت سود و زیان</div>
                        </li>
                        <li class="sidebarListItem w-100" routerLink='/investment/cash-flow' routerLinkActive='active'>
                            <i class="fa fa-exchange" aria-hidden="true"></i>
                            <div class="white-no py-1" style="margin-right: 15px;">گزارش جریان وجوه نقد</div>
                        </li>
                        <li class="sidebarListItem w-100" routerLink='/investment/portfolio-statement' routerLinkActive='active'>
                            <i class="fa fa-pie-chart" aria-hidden="true"></i>
                            <div class="white-no py-1" style="margin-right: 15px;">گزارش سبد سرمایه‌گذاری</div>
                        </li>
                    </ul>
                </div>
            </div>

            <!-- Agriculture (کشاورزی) -->
            <div class="card" [ngClass]="{'collapsed': !isAgricultureOpen}">
                <div class="card-header d-flex align-items-center justify-content-between cursor-pointer"
                    (click)="toggleSection('agriculture')">
                    <div>کشاورزی</div>
                    <i class="fa" [ngClass]="isAgricultureOpen ? 'fa-angle-up' : 'fa-angle-down'" aria-hidden="true"></i>
                </div>
                <div class="card-body" [ngClass]="{'d-none': !isAgricultureOpen}">
                    <ul class='sidebarList'>
                        <li class="sidebarListItem w-100" routerLink='/agriculture/balance-sheet' routerLinkActive='active'>
                            <i class="fa fa-book" aria-hidden="true"></i>
                            <div class="white-no py-1" style="margin-right: 15px;">گزارش صورت وضعیت مالی</div>
                        </li>
                        <li class="sidebarListItem w-100" routerLink='/agriculture/income-statement' routerLinkActive='active'>
                            <i class="fa fa-usd" aria-hidden="true"></i>
                            <div class="white-no py-1" style="margin-right: 15px;">گزارش صورت سود و زیان</div>
                        </li>
                        <li class="sidebarListItem w-100" routerLink='/agriculture/comprehensive-income' routerLinkActive='active'>
                            <i class="fa fa-line-chart" aria-hidden="true"></i>
                            <div class="white-no py-1" style="margin-right: 15px;">گزارش صورت سود و زیان جامع</div>
                        </li>
                        <li class="sidebarListItem w-100" routerLink='/agriculture/changes-in-equity' routerLinkActive='active'>
                            <i class="fa fa-balance-scale" aria-hidden="true"></i>
                            <div class="white-no py-1" style="margin-right: 15px;">گزارش صورت تغییرات در حقوق مالکانه</div>
                        </li>
                        <li class="sidebarListItem w-100" routerLink='/agriculture/cash-flow' routerLinkActive='active'>
                            <i class="fa fa-exchange" aria-hidden="true"></i>
                            <div class="white-no py-1" style="margin-right: 15px;">گزارش جریان وجوه نقد</div>
                        </li>
                        <li class="sidebarListItem w-100" routerLink='/agriculture/monthly-activity' routerLinkActive='active'>
                            <i class="fa fa-table" aria-hidden="true"></i>
                            <div class="white-no py-1" style="margin-right: 15px;">گزارش فعالیت ماهانه</div>
                        </li>
                    </ul>
                </div>
            </div>

            <!-- Bank (بانک‌ها) -->
            <div class="card" [ngClass]="{'collapsed': !isBankOpen}">
                <div class="card-header d-flex align-items-center justify-content-between cursor-pointer"
                    (click)="toggleSection('bank')">
                    <div>بانک‌ها</div>
                    <i class="fa" [ngClass]="isBankOpen ? 'fa-angle-up' : 'fa-angle-down'" aria-hidden="true"></i>
                </div>
                <div class="card-body" [ngClass]="{'d-none': !isBankOpen}">
                    <ul class='sidebarList'>
                        <li class="sidebarListItem w-100" routerLink='/bank/balance-sheet' routerLinkActive='active'>
                            <i class="fa fa-book" aria-hidden="true"></i>
                            <div class="white-no py-1" style="margin-right: 15px;">گزارش صورت وضعیت مالی</div>
                        </li>
                        <li class="sidebarListItem w-100" routerLink='/bank/income-statement' routerLinkActive='active'>
                            <i class="fa fa-usd" aria-hidden="true"></i>
                            <div class="white-no py-1" style="margin-right: 15px;">گزارش صورت سود و زیان</div>
                        </li>
                        <li class="sidebarListItem w-100" routerLink='/bank/comprehensive-income' routerLinkActive='active'>
                            <i class="fa fa-line-chart" aria-hidden="true"></i>
                            <div class="white-no py-1" style="margin-right: 15px;">گزارش صورت سود و زیان جامع</div>
                        </li>
                        <li class="sidebarListItem w-100" routerLink='/bank/changes-in-equity' routerLinkActive='active'>
                            <i class="fa fa-balance-scale" aria-hidden="true"></i>
                            <div class="white-no py-1" style="margin-right: 15px;">گزارش صورت تغییرات در حقوق مالکانه</div>
                        </li>
                        <li class="sidebarListItem w-100" routerLink='/bank/cash-flow' routerLinkActive='active'>
                            <i class="fa fa-exchange" aria-hidden="true"></i>
                            <div class="white-no py-1" style="margin-right: 15px;">گزارش جریان وجوه نقد</div>
                        </li>
                        <li class="sidebarListItem w-100" routerLink='/bank/monthly-activity' routerLinkActive='active'>
                            <i class="fa fa-table" aria-hidden="true"></i>
                            <div class="white-no py-1" style="margin-right: 15px;">گزارش فعالیت ماهانه</div>
                        </li>
                    </ul>
                </div>
            </div>

            <!-- Leasing (لیزینگ) -->
            <div class="card" [ngClass]="{'collapsed': !isLeasingOpen}">
                <div class="card-header d-flex align-items-center justify-content-between cursor-pointer"
                    (click)="toggleSection('leasing')">
                    <div>لیزینگ</div>
                    <i class="fa" [ngClass]="isLeasingOpen ? 'fa-angle-up' : 'fa-angle-down'" aria-hidden="true"></i>
                </div>
                <div class="card-body" [ngClass]="{'d-none': !isLeasingOpen}">
                    <ul class='sidebarList'>
                        <li class="sidebarListItem w-100" routerLink='/leasing/balance-sheet' routerLinkActive='active'>
                            <i class="fa fa-book" aria-hidden="true"></i>
                            <div class="white-no py-1" style="margin-right: 15px;">گزارش صورت وضعیت مالی</div>
                        </li>
                        <li class="sidebarListItem w-100" routerLink='/leasing/income-statement' routerLinkActive='active'>
                            <i class="fa fa-usd" aria-hidden="true"></i>
                            <div class="white-no py-1" style="margin-right: 15px;">گزارش صورت سود و زیان</div>
                        </li>
                        <li class="sidebarListItem w-100" routerLink='/leasing/comprehensive-income' routerLinkActive='active'>
                            <i class="fa fa-line-chart" aria-hidden="true"></i>
                            <div class="white-no py-1" style="margin-right: 15px;">گزارش صورت سود و زیان جامع</div>
                        </li>
                        <li class="sidebarListItem w-100" routerLink='/leasing/changes-in-equity' routerLinkActive='active'>
                            <i class="fa fa-balance-scale" aria-hidden="true"></i>
                            <div class="white-no py-1" style="margin-right: 15px;">گزارش صورت تغییرات در حقوق مالکانه</div>
                        </li>
                        <li class="sidebarListItem w-100" routerLink='/leasing/cash-flow' routerLinkActive='active'>
                            <i class="fa fa-exchange" aria-hidden="true"></i>
                            <div class="white-no py-1" style="margin-right: 15px;">گزارش جریان وجوه نقد</div>
                        </li>
                        <li class="sidebarListItem w-100" routerLink='/leasing/monthly-activity' routerLinkActive='active'>
                            <i class="fa fa-table" aria-hidden="true"></i>
                            <div class="white-no py-1" style="margin-right: 15px;">گزارش فعالیت ماهانه</div>
                        </li>
                    </ul>
                </div>
            </div>

            <!-- Insurance (بیمه) -->
            <div class="card" [ngClass]="{'collapsed': !isInsuranceOpen}">
                <div class="card-header d-flex align-items-center justify-content-between cursor-pointer"
                    (click)="toggleSection('insurance')">
                    <div>بیمه</div>
                    <i class="fa" [ngClass]="isInsuranceOpen ? 'fa-angle-up' : 'fa-angle-down'" aria-hidden="true"></i>
                </div>
                <div class="card-body" [ngClass]="{'d-none': !isInsuranceOpen}">
                    <ul class='sidebarList'>
                        <li class="sidebarListItem w-100" routerLink='/insurance/balance-sheet' routerLinkActive='active'>
                            <i class="fa fa-book" aria-hidden="true"></i>
                            <div class="white-no py-1" style="margin-right: 15px;">گزارش صورت وضعیت مالی</div>
                        </li>
                        <li class="sidebarListItem w-100" routerLink='/insurance/income-statement' routerLinkActive='active'>
                            <i class="fa fa-usd" aria-hidden="true"></i>
                            <div class="white-no py-1" style="margin-right: 15px;">گزارش صورت سود و زیان</div>
                        </li>
                        <li class="sidebarListItem w-100" routerLink='/insurance/comprehensive-income' routerLinkActive='active'>
                            <i class="fa fa-line-chart" aria-hidden="true"></i>
                            <div class="white-no py-1" style="margin-right: 15px;">گزارش صورت سود و زیان جامع</div>
                        </li>
                        <li class="sidebarListItem w-100" routerLink='/insurance/changes-in-equity' routerLinkActive='active'>
                            <i class="fa fa-balance-scale" aria-hidden="true"></i>
                            <div class="white-no py-1" style="margin-right: 15px;">گزارش صورت تغییرات در حقوق مالکانه</div>
                        </li>
                        <li class="sidebarListItem w-100" routerLink='/insurance/cash-flow' routerLinkActive='active'>
                            <i class="fa fa-exchange" aria-hidden="true"></i>
                            <div class="white-no py-1" style="margin-right: 15px;">گزارش جریان وجوه نقد</div>
                        </li>
                        <li class="sidebarListItem w-100" routerLink='/insurance/monthly-activity' routerLinkActive='active'>
                            <i class="fa fa-table" aria-hidden="true"></i>
                            <div class="white-no py-1" style="margin-right: 15px;">گزارش فعالیت ماهانه</div>
                        </li>
                    </ul>
                </div>
            </div>

            <!-- CapitalSupply (تأمین سرمایه) -->
            <div class="card" [ngClass]="{'collapsed': !isCapitalSupplyOpen}">
                <div class="card-header d-flex align-items-center justify-content-between cursor-pointer"
                    (click)="toggleSection('capital-supply')">
                    <div>تأمین سرمایه</div>
                    <i class="fa" [ngClass]="isCapitalSupplyOpen ? 'fa-angle-up' : 'fa-angle-down'" aria-hidden="true"></i>
                </div>
                <div class="card-body" [ngClass]="{'d-none': !isCapitalSupplyOpen}">
                    <ul class='sidebarList'>
                        <li class="sidebarListItem w-100" routerLink='/capital-supply/balance-sheet' routerLinkActive='active'>
                            <i class="fa fa-book" aria-hidden="true"></i>
                            <div class="white-no py-1" style="margin-right: 15px;">گزارش صورت وضعیت مالی</div>
                        </li>
                        <li class="sidebarListItem w-100" routerLink='/capital-supply/income-statement' routerLinkActive='active'>
                            <i class="fa fa-usd" aria-hidden="true"></i>
                            <div class="white-no py-1" style="margin-right: 15px;">گزارش صورت سود و زیان</div>
                        </li>
                        <li class="sidebarListItem w-100" routerLink='/capital-supply/comprehensive-income' routerLinkActive='active'>
                            <i class="fa fa-line-chart" aria-hidden="true"></i>
                            <div class="white-no py-1" style="margin-right: 15px;">گزارش صورت سود و زیان جامع</div>
                        </li>
                        <li class="sidebarListItem w-100" routerLink='/capital-supply/changes-in-equity' routerLinkActive='active'>
                            <i class="fa fa-balance-scale" aria-hidden="true"></i>
                            <div class="white-no py-1" style="margin-right: 15px;">گزارش صورت تغییرات در حقوق مالکانه</div>
                        </li>
                        <li class="sidebarListItem w-100" routerLink='/capital-supply/cash-flow' routerLinkActive='active'>
                            <i class="fa fa-exchange" aria-hidden="true"></i>
                            <div class="white-no py-1" style="margin-right: 15px;">گزارش جریان وجوه نقد</div>
                        </li>
                        <li class="sidebarListItem w-100" routerLink='/capital-supply/monthly-activity' routerLinkActive='active'>
                            <i class="fa fa-table" aria-hidden="true"></i>
                            <div class="white-no py-1" style="margin-right: 15px;">گزارش فعالیت ماهانه</div>
                        </li>
                    </ul>
                </div>
            </div>

            <li class="sidebarListItem w-100" routerLink='/annual-assembly' routerLinkActive='active'>
                <i class="fa fa-university font-12" aria-hidden="true"></i>
                <div class="py-1" style="margin-right: 15px;">تصمیمات مجمع عمومی عادی سالیانه</div>
            </li>

            <li class="sidebarListItem w-100" routerLink='/extra-annual-assembly' routerLinkActive='active'>
                <i class="fa fa-university font-12" aria-hidden="true"></i>
                <div class="py-1" style="margin-right: 15px;">تصمیمات مجمع عمومی فوق‌العاده سالیانه</div>
            </li>

            <li class="sidebarListItem w-100" routerLink='/extra-assembly' routerLinkActive='active'>
                <i class="fa fa-university font-12" aria-hidden="true"></i>
                <div class="py-1" style="margin-right: 15px;">تصمیمات مجمع عمومی فوق‌العاده</div>
            </li>

        </div>
    </div>
</div>
